export const sharedAvatarStyles = {
  backgroundColor: '#849A8F',
  fontWeight: 400,
  fontSize: '20px',
  letterSpacing: '.14px'
};
